import {Injectable} from '@angular/core';
import {TenantInformationService} from './tenant-information.service';
import {TenantSpecificAssetPipe} from '../pipes/tenant-specific-asset.pipe';
import {environment} from '../../environments/environment';

@Injectable({providedIn: 'root'})
export class ThemeService {
  private static readonly themeReadyClass = 'theme-ready';
  private static readonly themeReadyTimeoutMs = 4000;

  private readonly currentThemeLinkId = 'customer-theme';
  private readonly tenantSpecificAssetPipe: TenantSpecificAssetPipe;
  private themeReadyTimer?: ReturnType<typeof setTimeout>;

  constructor(private readonly tenantInformationService: TenantInformationService) {
    this.tenantSpecificAssetPipe = new TenantSpecificAssetPipe(this.tenantInformationService);
  }

  loadCustomerTheme(): void {
    const existingLink = document.getElementById(this.currentThemeLinkId) as HTMLLinkElement;
    const newLink = `${environment.themesAndAssetsUrl}${environment.name}/themes/${this.tenantInformationService.getTenantName()}/theme.css`;
    this.setFavicon();
    if (existingLink) {
      if (existingLink.href !== newLink) {
        existingLink.href = newLink;
      }
      return;
    }
    const link = document.createElement('link');
    link.id = this.currentThemeLinkId;
    link.rel = 'stylesheet';
    link.onload = () => this.revealApp();
    link.onerror = () => this.revealApp();
    link.href = newLink;

    document.head.appendChild(link);
    this.themeReadyTimer = setTimeout(() => this.revealApp(), ThemeService.themeReadyTimeoutMs);
  }

  setFavicon(): void {
    const favIcon = document.querySelector('#favIcon') as HTMLLinkElement | null;
    if (favIcon) {
      favIcon.href = this.tenantSpecificAssetPipe.transform('favicon.ico');
    }
  }

  /**
   * Uncovers the app, which index.html keeps hidden behind a blank page. Called once the
   * tenant theme has loaded, and also on error or after a timeout: an unreachable theme host
   * must never leave the app invisible.
   */
  private revealApp(): void {
    clearTimeout(this.themeReadyTimer);
    document.documentElement.classList.add(ThemeService.themeReadyClass);
  }
}
